<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('detailSociete.textEdition')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-4">
            <b-field :label="$t('detailSociete.infoSociete.textDevisDefaut')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold" v-html="societe.texteDevisDefaut"></span>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('detailSociete.infoSociete.textCommandeDefaut')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold" v-html="societe.texteCommandeDefaut"></span>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('detailSociete.infoSociete.textFactureDefaut')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold" v-html="societe.texteFactureDefaut"></span>
            </b-field>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-4">
            <b-field :label="$t('detailSociete.infoSociete.textDevis')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold" v-html="societe.texteDevisUnitaire"></span>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('detailSociete.infoSociete.textCommande')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold" v-html="societe.texteCommandeUnitaire"></span>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('detailSociete.infoSociete.textFacture')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold" v-html="societe.texteFactureUnitaire"></span>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('detailSociete.infoSociete.texteEditionCourrierTlpe')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold" v-html="societe.texteEditionCourrierTlpe"></span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('societes.texteEdition.texteEditionSignature.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-6">
              <b-field :label="$t('societes.texteEdition.texteEditionSignature.devis')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold" v-html="societe.texteEditionDevisSignature">
                </span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.texteEdition.texteEditionSignature.commande')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold" v-html="societe.texteEditionCommandeSignature">
                </span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field
                :label="
                  $t('societes.texteEdition.texteEditionSignature.isTextEditionSignatureUnderCard')"
                custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">
                  {{ societe.isTextEditionSignatureUnderCard
                    ? $t('general.oui') : $t('general.non') }}
                </span>
              </b-field>
            </div>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('societes.texteEdition.texteInfoBancaire.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field
              :label="$t('societes.texteEdition.texteInfoBancaire.texteEditionInfoPaiement')"
              custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold" v-html="societe.informationBancairePaiement">
              </span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    societe: Object,
  },
};
</script>
